const validate = {
  rules: {
    estado_id: {
      required: true,
    },
    nome: {
      required: true,
    },
    telefone: {
      required: true,
    },
    whatsapp: {
      required: true,
    },
    email: {
      required: true,
      email: true,
    },
    endereco: {
      required: true,
    },
  },
  messages: {
    estado_id: "O estado é obrigatório.",
    nome: "O nome é obrigatório.",
    telefone: "O telefone é obrigatório.",
    whatsapp: "O whatsapp é obrigatório.",
    email: {
      required: "O email é obrigatório.",
      email: "O email é inválido.",
    },
    endereco: "O endereço é obrigatório.",
  },
};

export default validate;
